export default "__VITE_ASSET__kwhoaOSf__"